<template>
  <ul-editor
    :height="height"
    ref="myMceEditor"
    v-model="content"
    :allowPaste="allowPaste"
    :toolbarOptions="toolbarOptions"
    @change="onChange"
    :uploaderConfig="{
      authorization: token,
      uptokenHost: COURSE_API_HOST,
      obsHost: RESOURCE_SERVER_HOST,
      config: {
        uphost: UPLOAD_SERVER_HOST,
        upprotocol: UPLOAD_SERVER_PROTOCOL
      }
    }">
  </ul-editor>
</template>

<script>
import { mapGetters } from 'vuex'
import UlEditor from 'ulearning-ui/packages/editor' // 下载依赖后修改编辑组件的obs引用
import { COURSE_API_HOST, RESOURCE_SERVER_HOST, UPLOAD_SERVER_HOST, UPLOAD_SERVER_PROTOCOL } from '@/config'
export default {
  name: 'editor',
  components: {
    UlEditor
  },
  props: {
    value: String,
    height: {
      type: Number,
      default: 500,
    },
    // 是否允许粘贴
    allowPaste: {
      type: Boolean,
      default: true
    },
  },
  watch: {
    value () {
      this.content = this.value
    }
  },
  computed: {
    ...mapGetters({'token': 'user/token'}),
  },
  data() {
    return {
      COURSE_API_HOST: COURSE_API_HOST,
      RESOURCE_SERVER_HOST: RESOURCE_SERVER_HOST,
      UPLOAD_SERVER_HOST: UPLOAD_SERVER_HOST,
      UPLOAD_SERVER_PROTOCOL: UPLOAD_SERVER_PROTOCOL,
      content: "",
      toolbarOptions: "fontselect | fontsizeselect | bold italic underline forecolor | numlist bullist alignleft | superscript subscript table formula imageupload"
    }
  },
  created() {
    
  },
  mounted() {
    if(this.value){
     this.$nextTick(()=>{
       this.content = this.value
     })
    }
  },
  methods: {
    onChange() {
      this.$emit('onChange',this.content)
    }
  }
}
</script>

<style lang="scss">
.tox-toolbar {
  .tox-toolbar__group:nth-child(1) {
    .tox-tbtn__select-label {
      width: 4em;
    }
  }
  .tox-toolbar__group:nth-child(2) {
    .tox-tbtn__select-label {
      width: 3em;
    }
  }
}
</style>